import { Component, computed, inject, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SkeletonModule } from 'primeng/skeleton';
import { VDropdownMenuComponent } from 'src/app/core/components/ui-kit/dropdown-menu/dropdown-menu.component';
import { VKitModule } from 'src/app/core/components/ui-kit/uikit.module';
import { SharedModule } from 'src/app/core/shared.module';
import { NotificationSchedule } from 'src/app/models/notifications';
import { MenuItem } from 'src/app/services/menu/menuItem';
import { TranslationService } from 'src/app/services/translation/translation.service';
import { IteratableListEntities } from 'src/app/store/common/list-entity';

@Component({
  imports: [
    SharedModule,
    SkeletonModule,
    VKitModule,
    VDropdownMenuComponent,
    ReactiveFormsModule,
  ],
  selector: 'v-notification-schedules-list',
  templateUrl: 'notification-schedules-list.component.html',
})
export class NotificationSchedulesListComponent {
  private translationService = inject(TranslationService);

  public scheduleEntities =
    input.required<IteratableListEntities<NotificationSchedule>>();

  public schedules = computed(() => {
    return this.scheduleEntities().entities;
  });

  public showSendTestNotification = input<boolean>(true);
  public showEdit = input<boolean>(true);

  public scheduleDeleted = output<string>();
  public scheduleDisabled = output<string>();
  public scheduleEnabled = output<string>();
  public scheduleEdit = output<string>();
  public sendTestNotificationForSchedule = output<string>();

  public getMenuItems(schedule: NotificationSchedule): MenuItem[] {
    return [
      ...(this.showEdit()
        ? [
            {
              label: 'resources.notificationSchedule.actions.edit',
              icon: 'pi pi-pencil',
              onClicked: () => this.scheduleEdit.emit(schedule.id),
            },
          ]
        : []),
      {
        label: schedule.enabled
          ? 'resources.notificationSchedule.actions.deactivate'
          : 'resources.notificationSchedule.actions.activate',
        icon: 'pi pi-check',
        onClicked: () =>
          schedule.enabled
            ? this.scheduleDisabled.emit(schedule.id)
            : this.scheduleEnabled.emit(schedule.id),
      },
      ...(this.showSendTestNotification()
        ? [
            {
              label: 'resources.notificationSchedule.actions.sendTest',
              icon: 'pi pi-send',
              onClicked: () =>
                this.sendTestNotificationForSchedule.emit(schedule.id),
            },
          ]
        : []),
      {
        label: 'resources.notificationSchedule.actions.delete.short',
        icon: 'pi pi-trash',
        onClicked: () => this.scheduleDeleted.emit(schedule.id),
      },
    ];
  }

  public scheduleFormGroup(schedule: NotificationSchedule) {
    const fg = new FormGroup({
      enabled: new FormControl(schedule.enabled),
    });

    fg.valueChanges.subscribe(v => {
      if (v.enabled) {
        this.scheduleEnabled.emit(schedule.id);
      } else {
        this.scheduleDisabled.emit(schedule.id);
      }
    });

    return fg;
  }

  public translateCronExpression(expression: string): string {
    return this.translationService.translateCronExpression(expression, {
      verbose: true,
    });
  }
}
